export const ambiente = 'produccion'
// export const ambiente = 'desarrollo'
// export const ambiente = 'local'

const axios = require('axios')

export const apiListadoContratos = async (body) => {
    let requestUrl
    switch (ambiente) {
        case 'desarrollo':
            requestUrl = 'https://cfp-backend-dev.azurewebsites.net/api/listadoContratos?code=3TzxNPH_RiWOWzVjWG2BvJripu6GvmVa5GhymdmnFIL1AzFustvtHg=='
            break;
        case 'local':
            requestUrl = 'http://localhost:7071/api/listadoContratos'
            break;
        case 'produccion':
        default:
            requestUrl = 'https://confipetrol-backend-prod.azurewebsites.net/api/listadoContratos?code=pgWB4kLjNRcoa_4gras68PB4Bq-1clzzH8C-v3jD5DMzAzFuBAo-hw=='
            break;
    }
    try {
        const request = await axios.post(requestUrl, body)
        switch (ambiente) {
            case 'desarrollo':
            case 'produccion':
            case 'local':
            default:
                return request.data
        }
    }
    catch (error) {
        console.log(error)
    }
}

export const apiListadoGerencias = async (body) => {
    let requestUrl
    switch (ambiente) {
        case 'desarrollo':
            requestUrl = 'https://cfp-backend-dev.azurewebsites.net/api/listadoGerencias?code=Ept5i6N3XQg3Q37dn_flPhu9h3_r8F4HiWV1CJawcb0ZAzFuQisCXQ=='
            break;
        case 'local':
            requestUrl = 'http://localhost:7071/api/listadoGerencias'
            break;
        case 'produccion':
        default:
            requestUrl = 'https://confipetrol-backend-prod.azurewebsites.net/api/listadoGerencias?code=MRsPhUfTsuHUUjiWxn9MmXscLeZksgjuzW6ocNlbfku_AzFulj1OpQ=='
            break;
    }
    try {
        const request = await axios.post(requestUrl, body)
        switch (ambiente) {
            case 'desarrollo':
            case 'produccion':
            case 'local':
            default:
                return request.data
        }
    }
    catch (error) {
        console.log(error)
        return []
    }
}

export const apiConsultaKactus = async (body) => {
    let requestUrl
    switch (ambiente) {
        case 'desarrollo':
            requestUrl = 'https://cfp-backend-dev.azurewebsites.net/api/consultaKactus?code=HgQlfmj/puvw9B7y3dhqsLo1587MoaF9NhdrHJWvJs0Cq0FkvlO02Q=='
            break;
        case 'local':
            requestUrl = 'http://localhost:7071/api/consultaKactus'
            break;
        case 'produccion':
        default:
            requestUrl = 'https://confipetrol-backend-prod.azurewebsites.net/api/consultaKactus?code=G1EovXGZRSA8b1zABWOnHJwGio5moB9WaOwDd47fN0tPAzFu9VtU4Q=='
            break;
    }
    try {
        const request = await axios.post(requestUrl, body)
        switch (ambiente) {
            case 'desarrollo':
            case 'produccion':
            case 'local':
            default:
                return request.data.result
        }
    }
    catch (error) {
        console.log(error)
    }
}

export const apiExportarInformeFinalMOC = async (body) => {
    let requestUrl
    switch (ambiente) {
        case 'desarrollo':
            requestUrl = 'https://cfp-backend-dev.azurewebsites.net/api/CrearInformeFinalMOC?code=HhRUwe8X8LBkuTOG4aAfds/82ILWSjLihi8fAmqbuHZUPHsjbSv4RA=='
            break;
        case 'local':
            requestUrl = 'http://localhost:7071/api/CrearInformeFinalMOC'
            break;
        case 'produccion':
        default:
            requestUrl = 'https://confipetrol-backend-prod.azurewebsites.net/api/CrearInformeFinalMOC?code=5aysa8YzvgijMtkWPFH0qkdiTCQraJdTjabIrExqlG9NAzFunmYoiQ=='
            break;
    }
    try {
        const request = await axios.post(requestUrl, body)
        switch (ambiente) {
            case 'desarrollo':
            case 'produccion':
            case 'local':
            default:
                return request.data
        }
    }
    catch (error) {
        console.log(error)
    }
}

export const apiExportarInformeFinalMONC = async (body) => {
    let requestUrl
    switch (ambiente) {
        case 'desarrollo':
            requestUrl = 'https://cfp-backend-dev.azurewebsites.net/api/CrearInformeFinalMONC?code=EwXBe8Q4M3HxCIWkLR0podweLKP6Q8l/pIUZX8rAr2zYzBFYwEiGNg=='
            break;
        case 'local':
            requestUrl = 'http://localhost:7071/api/CrearInformeFinalMONC'
            break;
        case 'produccion':
        default:
            requestUrl = 'https://confipetrol-backend-prod.azurewebsites.net/api/CrearInformeFinalMONC?code=gpg5PtJov12lutaPfI56fJ11VSp-_LZbt76UHLwkSvFMAzFul6TzlA=='
            break;
    }
    try {
        const request = await axios.post(requestUrl, body)
        switch (ambiente) {
            case 'desarrollo':
            case 'produccion':
            case 'local':
            default:
                return request.data
        }
    }
    catch (error) {
        console.log(error)
    }
}

export const apiExportarListaChequeo = async (body) => {
    let requestUrl
    switch (ambiente) {
        case 'desarrollo':
            requestUrl = 'https://cfp-backend-dev.azurewebsites.net/api/CrearListaChequeo?code=GVJDyGbZIvcf23YbOFREpt8fJuRlpUChVv/qDKXdHj5FfMmbPa/bSA=='
            // requestUrl = 'http://localhost:7071/api/CrearListaChequeo'
            break;
        case 'local':
            requestUrl = 'http://localhost:7071/api/CrearListaChequeo'
            break;
        case 'produccion':
        default:
            requestUrl = 'https://confipetrol-backend-prod.azurewebsites.net/api/CrearListaChequeo?code=YfxzHYxIZs2_op2SLTNnoJAoMiiyeu-PR7OFaZYw9hZiAzFuo23q9Q=='
            break;
    }
    try {
        const request = await axios.post(requestUrl, body)
        switch (ambiente) {
            case 'desarrollo':
            case 'produccion':
            case 'local':
            default:
                return request.data
        }
    }
    catch (error) {
        console.log(error)
    }
}

export const apiActualizarMail = async (body) => {
    let requestUrl
    switch (ambiente) {
        case 'desarrollo':
            requestUrl = 'https://cfp-backend-dev.azurewebsites.net/api/updateUserEmail?code=eNSSNXh7IUQN9iyMooHvNhx14Tx8ZFBmLWWGi72Ryza6svnt3nROiw=='
            break;

        case 'produccion':
        default:
            requestUrl = 'https://confipetrol-backend-prod.azurewebsites.net/api/updateUserEmail?code=33kPTbKdiWh9pPriLJORG_3GEAUkulE-UxAsOWC8zTq7AzFuz8dzOQ=='
            break;
    }
    try {
        const request = await axios.post(requestUrl, body)
        return request.data.result
    }
    catch (error) {
        console.log(error)
    }
}

export const apiInformeProrrogas = async (body) => {
    let requestUrl
    switch (ambiente) {
        case 'desarrollo':
            requestUrl = 'https://cfp-backend-dev.azurewebsites.net/api/consultaProrrogas?code=Us3NAGu29jArN4A0q2rViIHtNbZZdj5VheZhWFAgDGSmmrUHXiI4qA=='
            break;
        case 'local':
            requestUrl = 'http://localhost:7071/api/consultaProrrogas'
            break;
        case 'produccion':
        default:
            requestUrl = 'https://confipetrol-backend-prod.azurewebsites.net/api/consultaProrrogas?code=TK4FiT1F_b1hhOynHcdQE7_QKEr6_TYsb9MzkAj1tTIqAzFuj_fySg=='
            break;
    }
    try {
        const request = await axios.post(requestUrl, body)
        return request.data
    }
    catch (error) {
        console.log(error)
    }
}

export const apiGenerarProrroga = async (body) => {
    let requestUrl
    switch (ambiente) {
        case 'desarrollo':
            requestUrl = 'https://cfp-backend.azurewebsites.net/api/generarProrroga?code=FWcnrr-2Hc7gbzQRczxhgMLxCw8eufFAz_hyneAIBCvvAzFuiv-WqQ=='
            break;
        case 'local':
            requestUrl = 'http://localhost:7071/api/generarProrroga'
            break;
        case 'produccion':
        default:
            requestUrl = 'https://confipetrol-backend-prod.azurewebsites.net/api/generarProrroga?code=YzgZdcNRs8AVv7zPoW6em9vZnsRwuGnXpj6q52WcZ46cAzFuI1iJ0Q=='
            break;
    }
    try {
        const request = await axios.post(requestUrl, body)
        return request.data
    }
    catch (error) {
        console.log(error)
    }
}

export const apiInformeProrrogasGeneral = async (body) => {
    let requestUrl
    switch (ambiente) {
        case 'desarrollo':
            requestUrl = 'https://cfp-backend-dev.azurewebsites.net/api/consultaProrrogas?code=Us3NAGu29jArN4A0q2rViIHtNbZZdj5VheZhWFAgDGSmmrUHXiI4qA=='
            break;
        case 'local':
            requestUrl = 'http://localhost:7071/api/consultaProrrogasGeneral'
            break;
        case 'produccion':
        default:
            requestUrl = 'https://confipetrol-backend-prod.azurewebsites.net/api/consultaProrrogasGeneral?code=ZaKN0Y6CbgERcNpDg1H-nWFoaz6rnJ9cfzNaYbvo1i1qAzFu6ioDEQ=='
            break;
    }
    try {
        const request = await axios.post(requestUrl, body)
        return request.data
    }
    catch (error) {
        console.log(error)
    }
}

export const apiExisteTrabajador = async (body) => {
    let requestUrl
    switch (ambiente) {
        case 'desarrollo':
            requestUrl = 'https://cfp-backend-dev.azurewebsites.net/api/consultaExistenciaTrabajador?code=IadZYICzlc6KLnSO2tYJJZZayXXarGEnZv5cGZKHTbVfOZrAin9Baw=='
            break;
        case 'local':
            requestUrl = 'http://localhost:7071/api/consultaExistenciaTrabajador'
            break;
        case 'produccion':
        default:
            requestUrl = 'https://confipetrol-backend-prod.azurewebsites.net/api/consultaExistenciaTrabajador?code=zr_Dq8zVnTjpQcyYReZwyfsD9CO-pJe36280tFA2qB1_AzFueHvpJw=='
            break;
    }
    try {
        const request = await axios.post(requestUrl, body)
        switch (ambiente) {
            case 'desarrollo':
            case 'local':
            case 'produccion':
                return request.data === 'True'
            default:
                return request.data.result
        }
    }
    catch (error) {
        console.log(error)
    }
}

export const apiListadoReclutadores = async (body) => {
    let requestUrl
    switch (ambiente) {
        case 'desarrollo':
            requestUrl = 'https://cfp-backend-dev.azurewebsites.net/api/listadoReclutadores?code=ZgDa0HwYibWU/sT2Zj1NGdFLDwMNXoa4gllozZUfC7hRw2nivf4IxA=='
            break;
        case 'local':
            requestUrl = 'http://localhost:7071/api/listadoReclutadores'
            break;
        case 'produccion':
        default:
            requestUrl = 'https://confipetrol-backend-prod.azurewebsites.net/api/listadoReclutadores?code=YGLXtSYT8SfNyCn3X-NMFqp8u3SdFBk5JX643Xbz0XH7AzFuYozvrA=='
            break;
    }
    try {
        const request = await axios.post(requestUrl, body)
        switch (ambiente) {
            case 'desarrollo':
            case 'local':
            case 'produccion':
                return request.data
            default:
                return request.data.result
        }
    }
    catch (error) {
        console.log(error)
    }
}

export const apiListadoContratadores = async (body) => {
    let requestUrl
    switch (ambiente) {
        case 'desarrollo':
            requestUrl = 'https://cfp-backend-dev.azurewebsites.net/api/listadoContratadores?code=FNGpRQvYYik7pIVuaICHcQdaZlHqLznkrk89WCEPPXpMIYA5KNiujQ=='
            break;
        case 'local':
            requestUrl = 'http://localhost:7071/api/listadoContratadores'
            break;
        case 'produccion':
        default:
            requestUrl = 'https://confipetrol-backend-prod.azurewebsites.net/api/listadoContratadores?code=E7zkzCB7NTtEJUS-DfmRyFRZwgM5SDYNuE73FJ-_AIHUAzFu0aJWwQ=='
            break;
    }
    try {
        const request = await axios.post(requestUrl, body)
        switch (ambiente) {
            case 'desarrollo':
            case 'local':
            case 'produccion':
                return request.data
            default:
                return request.data.result
        }
    }
    catch (error) {
        console.log(error)
    }
}

export const apiListadoRetiros = async (body) => {
    let requestUrl
    switch (ambiente) {
        case 'desarrollo':
            requestUrl = 'https://cfp-backend-dev.azurewebsites.net/api/listadoRetiros?code=6deFmaQabwu8rVl63AOIjM/tl/BX2spMQVu0fdMQiKQDL2Mt5pmsdg=='
            break;
        case 'local':
            requestUrl = 'http://localhost:7071/api/listadoRetiros'
            break;
        case 'produccion':
        default:
            requestUrl = 'https://confipetrol-backend-prod.azurewebsites.net/api/listadoRetiros?code=0n6DbawDMrTb3wmpq7WGWV1t-p15kw5L2ck3jwQj5XUTAzFufkvQLg=='
            break;
    }
    try {
        const request = await axios.post(requestUrl, body)
        switch (ambiente) {
            case 'desarrollo':
            case 'local':
            case 'produccion':
                return request.data
            default:
                return request.data.result
        }
    }
    catch (error) {
        console.log(error)
    }
}

export const apiInformacionRetiro = async (body) => {
    let requestUrl
    switch (ambiente) {
        case 'desarrollo':
            requestUrl = 'https://cfp-backend-dev.azurewebsites.net/api/InformacionRetiro?code=oxfNI6aDy7uj2aKsDuoJwXJY4Dbd24Df/TnHYIRMpr90U5JgfJB1Dw=='
            break;
        case 'local':
            requestUrl = 'http://localhost:7071/api/InformacionRetiro';
            break;
        case 'produccion':
        default:
            requestUrl = 'https://confipetrol-backend-prod.azurewebsites.net/api/InformacionRetiro?code=QHNtu_I3fE4ooFGB7Bh0DkodNy0TsB1sI7Fkg5m5hugVAzFuhf1IvQ=='
            break;
    }
    try {
        const request = await axios.post(requestUrl, body)
        switch (ambiente) {
            case 'desarrollo':
            case 'local':
            case 'produccion':
                return request.data
            default:
                return request.data.result
        }
    }
    catch (error) {
        console.log(error)
    }
}

export const apiActualizarRetiro = async (body) => {
    let requestUrl
    switch (ambiente) {
        case 'desarrollo':
            requestUrl = 'https://cfp-backend-dev.azurewebsites.net/api/actualizarRetiro?code=rEnqsDzIjaiqRzRl6XsoQktbVy5lFHI6Bst66Ne80KU2fRwYAFfBpQ=='
            break;
        case 'local':
            requestUrl = 'http://localhost:7071/api/actualizarRetiro';
            break;
        case 'produccion':
        default:
            requestUrl = 'https://confipetrol-backend-prod.azurewebsites.net/api/actualizarRetiro?code=e8PvC1xU1pEbbnpZbSHKvtGDeRLBbi2YweLr5XYYEG0EAzFulFcGdA=='
            break;
    }
    try {
        const request = await axios.post(requestUrl, body)
        switch (ambiente) {
            case 'desarrollo':
            case 'local':
            case 'produccion':
                return request.data
            default:
                return request.data.result
        }
    }
    catch (error) {
        console.log(error)
    }
}

// ------------------------------Gestion Usuarios-----------------------------------------
export const apiGetAuthToken = async (body) => {
    let requestUrl
    switch (ambiente) {
        case 'desarrollo':
            requestUrl = 'https://cfp-backend-dev.azurewebsites.net/api/getAuthToken?code=JdCCaarOx6Ezr9OpqMQOwPNIQXdcEsvLbcmRMh7yCTnLAzFui1vZfA=='
            break;
        case 'local':
            requestUrl = 'http://localhost:7071/api/getAuthToken';
            break;
        case 'produccion':
        default:
            requestUrl = 'https://confipetrol-backend-prod.azurewebsites.net/api/getAuthToken?code=FeoplzU6dcghMCdFmoYzouzAhSUux-GkL_igx5dcfQjtAzFuZ2zw9A=='
            break;
    }
    try {
        const request = await axios.post(requestUrl, body)
        switch (ambiente) {
            case 'desarrollo':
            case 'local':
            case 'produccion':
                return request.data
            default:
                return request.data.result
        }
    }
    catch (error) {
        console.log(error)
    }
}

export const apiGetUserAuth = async (body) => {
    let requestUrl
    switch (ambiente) {
        case 'desarrollo':
            requestUrl = 'https://cfp-backend-dev.azurewebsites.net/api/getAuthUserData?code=gmOvMzrBD05Qvc7F9CmvcKqpxHK8PKb9MRRDKvMNFh_CAzFu8LbCjw=='
            break;
        case 'local':
            requestUrl = 'http://localhost:7071/api/getAuthUserData';
            break;
        case 'produccion':
        default:
            requestUrl = 'https://confipetrol-backend-prod.azurewebsites.net/api/getAuthUserData?code=X1758B9WukN8zb0DYVmbT61Hnv-KFPozqWHr2wFF-zGJAzFuuSX5rA=='
            break;
    }
    try {
        const request = await axios.post(requestUrl, body)
        switch (ambiente) {
            case 'desarrollo':
            case 'local':
            case 'produccion':
                return request
            default:
                return request.data.result
        }
    }
    catch (error) {
        console.log(error)
        return { status: error.response.status ?? 404 }
    }
}

export const apiUpdateUserAuth = async (body) => {
    let requestUrl
    switch (ambiente) {
        case 'desarrollo':
            requestUrl = 'https://cfp-backend-dev.azurewebsites.net/api/updateAuthUser?code=5HOGdNbTQaSjjxuWYaMR-1BD-GI3MXES7TsBOBy0iweNAzFuzOktGQ=='
            break;
        case 'local':
            requestUrl = 'http://localhost:7071/api/updateAuthUser';
            break;
        case 'produccion':
        default:
            requestUrl = 'https://confipetrol-backend-prod.azurewebsites.net/api/updateAuthUser?code=Upfq9v0ZyXr47XqAfWe_bSr_Qi23bZRyc9hxKAscWNmAAzFuXwfq0g=='
            break;
    }
    try {
        const request = await axios.post(requestUrl, body)
        switch (ambiente) {
            case 'desarrollo':
            case 'local':
            case 'produccion':
                return request
            default:
                return request.data.result
        }
    }
    catch (error) {
        console.log(error)
        return error.response
    }
}

export const apiGenerarInformeAPE = async (body) => {
    const requestUrl = 'https://us-central1-confipetrol-f7147.cloudfunctions.net/ape_consultaPersonalizada'
    try {
        const request = await axios.post(requestUrl, body)
        return request.data
    }
    catch (error) {
        console.log(error)
        throw error
    }
}
